import { useEffect, useState } from 'react'

/** A read shorter than this never shows the bar, so a quick poll doesn't flicker. */
const SHOW_AFTER_MS = 300

/**
 * The thin bar under a shell's tab strip while anything on screen is being read again (the loading standard, case 5,
 * 26 October 2026): a refresh, the half-minute poll or an update after a change. What is shown stays; only this runs.
 */
export function ReadingBar({ reading }: { reading: boolean }) {
  const [shown, setShown] = useState(false)
  useEffect(() => {
    if (!reading) {
      setShown(false)
      return
    }
    const timer = window.setTimeout(() => setShown(true), SHOW_AFTER_MS)
    return () => window.clearTimeout(timer)
  }, [reading])
  return (
    <div aria-hidden="true" className="relative h-0.5 overflow-hidden">
      {shown && <div className="absolute inset-y-0 left-0 w-1/3 bg-marine motion-safe:animate-[reading_1.2s_ease-in-out_infinite] motion-reduce:w-full motion-reduce:opacity-60" />}
    </div>
  )
}
